import _styled from "@emotion/styled/base";
import PropTypes from 'prop-types';
const Separator = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ecw7m630"
} : {
  target: "ecw7m630",
  label: "Separator"
})("width:", props => props.width, ";height:", _ref => {
  let {
    height
  } = _ref;
  return height;
}, "px;background-color:", _ref2 => {
  let {
    color
  } = _ref2;
  return color;
}, ";margin:", _ref3 => {
  let {
    spacing
  } = _ref3;
  return spacing;
}, "px auto;display:block;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9hcHAvbm9kZV9tb2R1bGVzL0BpbnRlcm5lc3Mvd2ViLWNvcmUvc3JjL2NvbXBvbmVudHMvc3RydWN0dXJlL1NlcGFyYXRvci9TZXBhcmF0b3IuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRzRCIiwiZmlsZSI6Ii9hcHAvbm9kZV9tb2R1bGVzL0BpbnRlcm5lc3Mvd2ViLWNvcmUvc3JjL2NvbXBvbmVudHMvc3RydWN0dXJlL1NlcGFyYXRvci9TZXBhcmF0b3IuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkICAgIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5jb25zdCBTZXBhcmF0b3IgPSBzdHlsZWQuZGl2YFxuICB3aWR0aDogJHtwcm9wcyA9PiBwcm9wcy53aWR0aH07XG4gIGhlaWdodDogJHsoeyBoZWlnaHQgfSkgPT4gaGVpZ2h0fXB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyh7IGNvbG9yIH0pID0+IGNvbG9yfTtcbiAgbWFyZ2luOiAkeyh7IHNwYWNpbmcgfSkgPT4gc3BhY2luZ31weCBhdXRvO1xuICBkaXNwbGF5OiBibG9jaztcbmA7XG5cblNlcGFyYXRvci5wcm9wVHlwZXMgPSB7XG4gIGNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBoZWlnaHQ6IFByb3BUeXBlcy5udW1iZXIsXG4gIHNwYWNpbmc6IFByb3BUeXBlcy5udW1iZXIsXG4gIHdpZHRoOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuU2VwYXJhdG9yLmRlZmF1bHRQcm9wcyA9IHtcbiAgLy9UT0RPIFRIRU1FPyFcbiAgY29sb3I6ICcjZWZlZmVmJyxcbiAgaGVpZ2h0OiAxLFxuICBzcGFjaW5nOiA0MCxcbiAgd2lkdGg6ICcxMDAlJyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFNlcGFyYXRvcjtcbiJdfQ== */"));
Separator.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  spacing: PropTypes.number,
  width: PropTypes.string
};
Separator.defaultProps = {
  //TODO THEME?!
  color: '#efefef',
  height: 1,
  spacing: 40,
  width: '100%'
};
export default Separator;